export default "__VITE_ASSET__e0c1ee41__"